import moment from "moment";

/**
 * Formats the flexible cancellation policy into a human-readable string.
 * Handles potential edge cases where time or date might be missing.
 *
 * @param {Object} policy - The cancellation policy object.
 * @param {string} policy.type - The type of cancellation policy (e.g., "FLEXIBLE" or "NON_REFUNDABLE").
 * @param {string|null} policy.sameDayFlexibleUntil - Time in "HH:mm" format (e.g., "14:00") or null.
 * @param {string|null} policy.cancellationUntilDate - Date in "YYYY-MM-DD" format (e.g., "2025-02-06") or null.
 * @returns {string|null} - The formatted cancellation policy message.
 */
function formatFlexibleCancellationPolicy(policy) {
  const { type, sameDayFlexibleUntil, cancellationUntilDate } = policy;

  if (type !== "FLEXIBLE" || !cancellationUntilDate) {
    return null; // Non-flexible policies shouldn't be formatted
  }

  // Parse the cancellation date
  const formattedDate = moment(cancellationUntilDate, "YYYY-MM-DD").format(
    "MMMM D, YYYY"
  );

  // Handle potential time formatting
  let timePart = "";
  if (sameDayFlexibleUntil) {
    // Append a dummy date to ensure Moment can parse it correctly
    const fullTime = moment(
      `${cancellationUntilDate} ${sameDayFlexibleUntil}`,
      "YYYY-MM-DD HH:mm"
    );
    if (fullTime.isValid()) {
      timePart = ` at ${fullTime.format("h:mm A")}`;
    }
  }

  return `Free cancellation available until ${formattedDate}${timePart}`;
}

export default formatFlexibleCancellationPolicy;
